export default __webpack_public_path__ + "static/hackathon-grid-5-6fb2cf0ea5597e99ce77006fd31c6056.png";